import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { Accordion } from '@/modules/common/components/Accordion';
import { StocksTable } from './components/StocksTable';
import { Money } from '@/modules/common/components/MoneyV2';

import { PortfolioSection } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  sections: PortfolioSection[];
  isLoading: boolean;
  hasError: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChartLegend',
  props: {
    sections: null,
    isLoading: { type: Boolean },
    hasError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sections: PortfolioSection[];
  isLoading: boolean;
  hasError: boolean;
}



const openSectionsMap = ref<Record<number, boolean>>({});

watch(
  () => props.sections,
  sections => {
    const newOpenSectionsMap: Record<number, boolean> = {};

    sections.forEach((_section, index) => {
      newOpenSectionsMap[index] = false;
    });

    openSectionsMap.value = newOpenSectionsMap;
  },
  { immediate: true }
);

const handleToggleAccordion = (
  isOpen: boolean,
  index: number,
  section: PortfolioSection
) => {
  if (!verifyIfSectionHasItems(section)) return;
  openSectionsMap.value[index] = isOpen;
};

const verifyIfSectionHasItems = (section: PortfolioSection) => {
  return section.types.stocks && section.types.stocks.items.length > 0;
};

return { __sfc: true,props, openSectionsMap, handleToggleAccordion, verifyIfSectionHasItems, BaseText, SkeletonLoader, Accordion, StocksTable, Money, NebraskaColors }
}

})